const compare = (a, b) => {
  if (typeof a === 'string') {
    a = a.toUpperCase();
    b = b.toUpperCase();
  }
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

export default function getSortMethod(method) {
  const sortMethods = {
    none: i => i,
    title: i => i.sort((a, b) => compare(a.title, b.title)),
    titleRev: i => i.sort((a, b) => -compare(a.title, b.title)),
    created: i => i.sort((a, b) => compare(new Date(a.date_created), new Date(b.date_created))),
    createdRev: i => i.sort((a, b) => -compare(new Date(a.date_created), new Date(b.date_created))),
    modified: i => i.sort((a, b) => compare(new Date(a.date_modified), new Date(b.date_modified))),
    modifiedRev: i => i.sort((a, b) => -compare(new Date(a.date_modified), new Date(b.date_modified))),
  };
  return sortMethods[method];
}
